<template>
    <section class="col s12">
        <!-- PONTUAÇÃO -->
        <div class="row">
            <div class="input-field col s4">
                <input type="number"
                       id="txt_estudantes_orientados_quantidade" name="txt_estudantes_orientados_quantidade"
                       maxlength="2"
                       min="0"
                       max="99"
                       @keypress="somenteNumeros"
                       v-model.number="quantidadeSelecionada"
                       :disabled="allDisabled">
                <label for="txt_estudantes_orientados_quantidade">Estudantes vinculados à ação</label>
            </div>

            <div class="input-field col s4">
                <select name="sel_qtd_estudantes_orientados_opcao" id="sel_qtd_estudantes_orientados_opcao"
                        :disabled="allDisabled"
                        v-model="opcaoSelecionada"
                        @change.stop="selecionaPontuacaoDeAcordoComOpcaoSelecionada"
                        tipo="materialize">
                    <option value="" disabled>Selecione uma opção</option>

                    <option :value="opcaoSelecionada"
                            v-if="opcaoSelecionada && !retornaConfiguracaoSelecionadaPelaOpcao">{{ opcaoSelecionada }}</option>

                    <option v-for="(config, config_i) in configuracaoDeNotas"
                            :key="config_i"
                            :title="config.opcao"
                            :value="config.opcao">{{ config.opcao }}</option>
                </select>
                <label for="sel_qtd_estudantes_orientados_opcao">Opção para pontuação</label>
            </div>

            <div class="input-field col s4">
                <input type="text"
                       id="txt_qtd_estudantes_orientados_pontuacao" name="txt_qtd_estudantes_orientados_pontuacao"
                       :value="pontuacaoSelecionada != null ? (pontuacaoSelecionada + ' pontos') : 'Não há pontuação definida!'"
                       disabled>
                <label for="txt_qtd_estudantes_orientados_pontuacao">Pontuação</label>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    name: "at_qtd_estudantes_orientados",
    props: {

        pQuantidadeSelecionada: {
            type: Number,
            default: null,
        },
        pOpcaoSelecionada: {
            type: String,
            default: null,
        },
        pPontuacaoSelecionada: {
            type: Number,
            default: null,
        },
        configuracaoDeNotas: {
            type: Array,
            default: () => { return [] },
        },
        allDisabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            opcaoSelecionada: this.pOpcaoSelecionada,
            pontuacaoSelecionada: this.pPontuacaoSelecionada,
            quantidadeSelecionada: this.pQuantidadeSelecionada,
        }
    },
    watch: {
        pOpcaoSelecionada(newValue) {
            this.opcaoSelecionada = newValue
        },
        opcaoSelecionada(newValue) {
            this.$emit('update:pOpcaoSelecionada', newValue)
        },

        pPontuacaoSelecionada(newValue) {
            this.pontuacaoSelecionada = newValue
        },
        pontuacaoSelecionada(newValue) {
            this.$emit('update:pPontuacaoSelecionada', newValue)
        },

        pQuantidadeSelecionada(newValue) {
            this.quantidadeSelecionada = newValue
        },
        quantidadeSelecionada(newValue) {
            this.$emit('update:pQuantidadeSelecionada', newValue)
        },
    },
    computed: {

        retornaConfiguracaoSelecionadaPelaOpcao(){
            if(!this.opcaoSelecionada)
                return null;

            return this.buscaConfiguracaoSelecionadaPelaOpcao()
        },
    },
    methods: {

        buscaConfiguracaoSelecionadaPelaOpcao(){
            return _.find(this.configuracaoDeNotas, (config) => {
                return config.opcao === this.opcaoSelecionada;
            });
        },

        selecionaPontuacaoDeAcordoComOpcaoSelecionada(){
            const config = this.buscaConfiguracaoSelecionadaPelaOpcao()

            this.pontuacaoSelecionada = config.pontos
        },

        somenteNumeros(e){
            const char = String.fromCharCode(e.keyCode);

            const pattern = '[0-9]';

            if (char.match(pattern))
                return true;
            else {
                e.preventDefault()
                return false;
            }
        }
    },
}
</script>

<style scoped>

</style>
